// 格式化地址函数
const tree = list => {
  const hashTable = Object.create(null);
  list.forEach(aData => {
    if (!aData.pid) {
      hashTable[aData.id] = { ...aData, children: [] };
    } else {
      hashTable[aData.id] = { ...aData };
    }
  });
  const dataTree = [];
  list.forEach(aData => {
    if (aData.pid) {
      if (hashTable[aData.pid])
        hashTable[aData.pid].children.push(hashTable[aData.id]);
    } else dataTree.push(hashTable[aData.id]);
  });
  return dataTree;
};
export const formatLocations = locationObj => {
  const fixed = [];
  for (const id in locationObj) {
    if ({}.hasOwnProperty.call(locationObj, id)) {
      let pid;
      const tmpObj = {
        id,
        text: locationObj[id],
      };
      if (id.slice(2, 6) !== '0000' && id.slice(4, 6) === '00') {
        pid = `${id.slice(0, 2)}0000`;
        if (!locationObj[pid]) {
          pid = `${id.slice(0, 2)}0000`;
        }
        if (pid) tmpObj.pid = pid;
        fixed.push(tmpObj);
      } else if (id.slice(2, 6) === '0000') {
        if (pid) tmpObj.pid = pid;
        fixed.push(tmpObj);
      }
    }
  }
  return tree(fixed);
};
export const defaultImgUrl =
  'https://resource.chunyu.mobi/@/media/images/2022/07/21/0686/0ed4a65f19b8_w100_h100_.png';
